/* Settings → Usage: the credits agents spent, apart from Billing, which is payments only.
   The usage card sits on top here too; its Upgrade goes to Billing. */
import { useBillingSummary } from "@/shared/api/billing";
import { Group, Pane } from "@/shared/components/settings-atoms";
import { openBilling } from "@/shared/components/UpgradeButton";
import { PLANS } from "@/shared/lib/plans";
import StatementGroup from "./StatementGroup";
import UsageCard from "./UsageCard";

export default function UsageSection() {
  const { data: summary } = useBillingSummary();
  const higher = !!summary && PLANS.findIndex((p) => p.id === summary.plan.name) < PLANS.length - 1;
  return (
    <Pane title="Usage" desc="Credits your agents spent — chats, tasks and sandbox time.">
      {summary && (
        <Group>
          <UsageCard summary={summary} onUpgrade={higher ? openBilling : undefined} />
        </Group>
      )}
      <StatementGroup kind="usage" title="Credits used" empty="No usage yet." />
    </Pane>
  );
}
